"use client";
import { useRef as P, useState as o, useEffect as z } from "react";
const j = (p = 0) => {
  const s = P(null), i = P(null), [C, m] = o(!1), [D, v] = o(!0), l = () => {
    var S, k, M, w;
    const t = ((S = s.current) == null ? void 0 : S.getBoundingClientRect().left) || 0, e = ((k = s.current) == null ? void 0 : k.getBoundingClientRect().right) || 0, n = ((M = i.current) == null ? void 0 : M.getBoundingClientRect().left) || 0, c = ((w = i.current) == null ? void 0 : w.getBoundingClientRect().right) || 0, g = Math.round(
      t + p - n
    ), f = Math.round(
      e + p - c
    );
    return { offsetLeft: g, offsetRight: f };
  }, a = (t, e) => {
    m(t > 3), v(e < -3);
  }, h = (t) => {
    var f;
    const { offsetLeft: e, offsetRight: n } = l(), c = t === "left" ? e - 250 : e + 250, g = t === "left" ? n - 250 : n + 250;
    (f = s.current) == null || f.scrollTo({ left: c, behavior: "smooth" }), a(c, g);
  }, B = () => h("left"), E = () => h("right"), I = () => {
    const { offsetLeft: t, offsetRight: e } = l();
    a(t, e);
  }, [O, T] = o(0), [u, W] = o([0, 0]), [R, L] = o(!1), [r, d] = o(0), X = (t) => {
    t.preventDefault(), t.stopPropagation(), T(t.clientX), d(0), L(!0);
    const { offsetLeft: e, offsetRight: n } = l();
    W([e, n]);
  }, b = (t) => {
    var n;
    t.preventDefault(), t.stopPropagation();
    const e = t.clientX - O;
    d(R ? -1 * e : 0), R && ((n = s.current) == null || n.scrollTo({ left: u[0] + r }), a(
      u[0] + r,
      u[1] + r
    ));
  }, x = (t) => {
    t.preventDefault(), t.stopPropagation(), L(!1);
  };
  return z(() => {
    const t = (e) => {
      r > 3 && (e.stopPropagation(), e.preventDefault());
    };
    return document.addEventListener("click", t, !0), () => document.removeEventListener("click", t, !0);
  }, [r]), {
    wrapRef: s,
    innerRef: i,
    maskLeft: C,
    maskRight: D,
    onScrollLeft: B,
    onScrollRight: E,
    handlerChangeMask: I,
    onMouseStart: X,
    onMouseMove: b,
    onSwipeEnd: x
  };
};
export {
  j as default
};
